// Initialize AOS (Animate On Scroll)
AOS.init({
    duration: 800,
    easing: 'ease-out-cubic',
    once: true,
    offset: 50
});

// Ensure video plays on mobile (iOS fix)
const heroVideo = document.getElementById('heroVideo');
if (heroVideo) {
    // Try to play video on load
    heroVideo.play().catch(() => {
        // If autoplay fails, play on first user interaction
        document.addEventListener('touchstart', function playVideo() {
            heroVideo.play();
            document.removeEventListener('touchstart', playVideo);
        }, { once: true });
    });
}

// Navigation scroll effect
const nav = document.getElementById('nav');
window.addEventListener('scroll', () => {
    nav.classList.toggle('scrolled', window.scrollY > 100);
});

// Mobile nav toggle
const navToggle = document.getElementById('navToggle');
if (navToggle) {
    navToggle.addEventListener('click', () => {
        document.querySelector('.nav-links').classList.toggle('active');
    });
}

// Video toggle
const videoIcon = document.getElementById('videoIcon');
const videoToggle = document.getElementById('videoToggle');
if (videoToggle && heroVideo) {
    videoToggle.addEventListener('click', () => {
        if (heroVideo.paused) {
            heroVideo.play();
            videoIcon.classList.replace('fa-play', 'fa-pause');
        } else {
            heroVideo.pause();
            videoIcon.classList.replace('fa-pause', 'fa-play');
        }
    });
}

// Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
        }
        // Close mobile nav if open
        document.querySelector('.nav-links').classList.remove('active');
    });
});

// Contact form submission (guarded - cards layout has no form)
const contactForm = document.getElementById('contactForm');
if (contactForm) {
    contactForm.addEventListener('submit', (e) => {
        e.preventDefault();
        alert('Thanks for reaching out! We\'ll get back to you soon.');
        e.target.reset();
    });
}

// Counter Animation
const counters = document.querySelectorAll('.counter');
const speed = 100;

const animateCounter = (counter) => {
    const target = +counter.getAttribute('data-target');
    const increment = target / speed;
    let current = 0;

    const updateCount = () => {
        current += increment;
        if (current < target) {
            counter.innerText = Math.ceil(current);
            requestAnimationFrame(updateCount);
        } else {
            counter.innerText = target;
        }
    };
    updateCount();
};

// Intersection Observer to trigger counters when visible
const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            const counter = entry.target;
            animateCounter(counter);
            counterObserver.unobserve(counter);
        }
    });
}, { threshold: 0.5 });

counters.forEach(counter => counterObserver.observe(counter));

/* =====================================================
   HIGH-FIDELITY SCROLL ANIMATIONS
   ===================================================== */

const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

/* --- 1. Scroll progress bar (vertical) --- */
(function () {
    const bar = document.getElementById('scrollProgress');
    if (!bar) return;
    let ticking = false;
    const update = () => {
        const h = document.documentElement;
        const max = h.scrollHeight - h.clientHeight;
        const pct = max > 0 ? (h.scrollTop || window.scrollY) / max : 0;
        bar.style.transform = `scaleY(${pct})`;
        ticking = false;
    };
    window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
})();

/* --- 2. Hero parallax + zoom on scroll --- */
(function () {
    if (reduceMotion) return;
    const heroMedia = document.querySelector('.hero-media');
    const heroContent = document.querySelector('.hero-content');
    if (!heroMedia) return;
    let ticking = false;
    const update = () => {
        const y = window.scrollY;
        const vh = window.innerHeight;
        const t = Math.min(y / vh, 1);
        heroMedia.style.transform = `translate3d(0, ${y * 0.35}px, 0) scale(${1 + t * 0.08})`;
        if (heroContent) {
            heroContent.style.transform = `translate3d(0, ${y * 0.2}px, 0)`;
            heroContent.style.opacity = `${Math.max(1 - t * 1.4, 0)}`;
        }
        ticking = false;
    };
    window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
})();

/* --- 3. Reveal-on-scroll for sections, with chapter label slide --- */
(function () {
    const revealEls = document.querySelectorAll('.reveal, .chapter-label, .section-h, .polaroid-track');
    if (!revealEls.length) return;
    const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
            if (e.isIntersecting) {
                e.target.classList.add('in-view');
                io.unobserve(e.target);
            }
        });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    revealEls.forEach((el) => io.observe(el));
})();

/* --- 4. 3D tilt on polaroids (cursor-driven) --- */
(function () {
    if (reduceMotion || matchMedia('(hover: none)').matches) return;
    const items = document.querySelectorAll('.polaroid-item');
    items.forEach((item) => {
        item.addEventListener('mousemove', (ev) => {
            const r = item.getBoundingClientRect();
            const x = (ev.clientX - r.left) / r.width;
            const y = (ev.clientY - r.top) / r.height;
            const rx = (0.5 - y) * 14;
            const ry = (x - 0.5) * 14;
            item.style.transform = `perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg) translateZ(20px) scale(1.04)`;
        });
        item.addEventListener('mouseleave', () => {
            item.style.transform = '';
        });
    });
})();

/* --- 5. Magnetic CTAs --- */
(function () {
    if (reduceMotion || matchMedia('(hover: none)').matches) return;
    const magnets = document.querySelectorAll('.hero-cta, .nav-cta, .contact-card');
    magnets.forEach((m) => {
        m.addEventListener('mousemove', (ev) => {
            const r = m.getBoundingClientRect();
            const x = ev.clientX - (r.left + r.width / 2);
            const y = ev.clientY - (r.top + r.height / 2);
            const strength = m.classList.contains('contact-card') ? 0.06 : 0.18;
            m.style.transform = `translate(${x * strength}px, ${y * strength}px)`;
        });
        m.addEventListener('mouseleave', () => {
            m.style.transform = '';
        });
    });
})();

/* --- 6. Ambient glow on dark sections + cursor spotlight on desktop --- */
(function () {
    const spotlightSections = document.querySelectorAll('.story, .contact, .menu, .vibe');
    if (!spotlightSections.length) return;
    // Always add the class — ambient drift runs everywhere (including mobile)
    spotlightSections.forEach((sec) => sec.classList.add('has-spotlight'));
    // Cursor-driven hot spot only on devices with a real pointer
    if (reduceMotion || matchMedia('(hover: none)').matches) return;
    spotlightSections.forEach((sec) => {
        sec.addEventListener('mousemove', (ev) => {
            const r = sec.getBoundingClientRect();
            const x = ((ev.clientX - r.left) / r.width) * 100;
            const y = ((ev.clientY - r.top) / r.height) * 100;
            sec.style.setProperty('--spotlight-x', `${x}%`);
            sec.style.setProperty('--spotlight-y', `${y}%`);
        });
    });
})();

/* --- 7. Ticker speed reacts to scroll velocity --- */
(function () {
    if (reduceMotion) return;
    const tracks = document.querySelectorAll('.ticker-track');
    if (!tracks.length) return;
    let lastY = window.scrollY;
    let velocity = 0;
    let raf = null;
    const decay = () => {
        velocity *= 0.92;
        const speed = 1 + Math.min(Math.abs(velocity) * 0.04, 2.2);
        tracks.forEach((t) => { t.style.animationDuration = `${30 / speed}s`; });
        if (Math.abs(velocity) > 0.1) raf = requestAnimationFrame(decay);
        else raf = null;
    };
    window.addEventListener('scroll', () => {
        const y = window.scrollY;
        velocity = (velocity * 0.6) + (y - lastY) * 0.4;
        lastY = y;
        if (!raf) raf = requestAnimationFrame(decay);
    }, { passive: true });
})();
